<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level" style="margin-bottom: 0px">
  <span i18n='Attributes section title@@customerOverviewComponent.sectionHeading.attributes' class="esf-action-heading__text">Attributes</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple" [disabled]="spinnerLoading" (click)="editAttributes()" [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile customer-overview-box-width" style="flex: 1;">
  <div class="esf-info-tile__content">

    <ng-container *ngIf="!spinnerLoading">

      <div class="flex-attributes" *ngIf="attributes?.length">
        <div class="esf-tags attribute-padding" *ngFor="let attribute of attributes">
          <!-- <span [ngClass]="{ 'esf-tag--success': attribute.status === 'active', 'esf-tag--alert': attribute.status === 'inactive'}" class="esf-tag">{{attribute.name}}</span> -->
          <ng-container [ngSwitch]="attribute.status">

            <ng-container *ngSwitchCase="'active'">
              <span class="esf-tag"
                    [ngClass]="{'text-color-dark': !attribute.isDark, 'text-color-light': attribute.isDark}"
                    [style.background-color]="attribute.color">{{attribute.displayName}}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'inactive'">
              <span class="esf-tag esf-tag--alert">{{attribute.displayName}}
              </span>
            </ng-container>
          </ng-container>

        </div>
      </div>

      <section class="esf-empty-state flex-empty-state" *ngIf="!attributes?.length">
        <div>
          <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
            <use xlink:href="#esf-icon-attributes"></use>
          </svg>
        </div>
        <p class="esf-paragraph">
          <small i18n='Text for empty state@@customerOverviewComponent.text.noAttributes'>There are no attributes yet.</small>
        </p>
        <button class="esf-button esf-button--standard esf-button--filled esf-button--small" (click)="editAttributes()">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-plus"></use>
          </svg>
          <span class="esf-button__icon-text" i18n='Button for empty state@@customerOverviewComponent.button.addNewAttribute'>Add a new attribute</span>
        </button>
      </section>

    </ng-container>

    <section class="esf-empty-state flex-empty-state" *ngIf="spinnerLoading">
      <app-spinner [name]="spinnerName" [(show)]="spinnerLoading"></app-spinner>
    </section>

  </div>
</div>
